/**
 * Constants for Subrogation Payment module
 * Contains all text messages and labels used in subrogation payment forms
 *
 * Note: Currently contains Japanese text. For future localization support,
 * consider implementing a localization framework (e.g., i18next) where these
 * constants would be replaced with translation keys that map to language-specific
 * strings in separate localization files.
 */

/**
 * LocalStorage key for syncing month/year between Subrogation Payment pages
 */
export const SUBROGATION_PAYMENT_MONTH_YEAR_KEY = "subrogationPaymentMonthYear";

/**
 * Information messages displayed in the billing breakdown section
 */
export const SUBROGATION_PAYMENT_MESSAGES = {
  /**
   * Message about restoration fee and renewal fee claim range varying by product
   */
  RESTORATION_RENEWAL_FEE_NOTE: "※退去精算費用、賃貸借契約更新料の保証範囲は商品により異なります。",

  /**
   * Message about claim deadline for move-out settlement (60 days from move-out date)
   */
  MOVE_OUT_SETTLEMENT_DEADLINE: "※退去精算に掛かる代弁請求は、退去明渡日から30日以内が期限です。"
} as const;

export const SUBROGATION_PAYMENT_ALLOWED_EXTENSIONS = ["pdf", "png", "jpg", "jpeg"];
